import { useState, useEffect } from 'react';
import { useProfileStore } from '@lib/store';
import { useMediaQuery, useRouteHook } from '@shared/hooks';
import { RoutePaths } from '@shared/utils';
import { ChangePasswordModal, SuccessChangePasswordModal } from './widgets';
import { Button, Input, PageLayout } from '@shared/widgets';
import ChangePasswordIcon from '@assets/images/profile/change_pass_ico.svg';
import ArrowMobileIcon from '@assets/images/arrow_mobile.svg';
import bgImg from '@assets/images/profile/bg-01.png';
import mobileBgImg from '@assets/images/profile/profile_bg_mobile.png';

export const ProfilePage = () => {
  const { navigate } = useRouteHook();

  const profileStore = useProfileStore();

  const [showChangePasswordModal, setShowChangePasswordModal] = useState<boolean>(false);
  const [showSuccessChangePasswordModal, setShowSuccessChangePasswordModal] = useState<boolean>(false);

  const isMaxMd = useMediaQuery('(max-width: 768px)');

  useEffect(() => {
    profileStore.get();
  }, []);

  return (
    <PageLayout>
      <div className='mx-auto flex'>
        <div className='w-[11.2%] max-md:hidden'>
          <div className='mt-[125px] border-t border-[#000000]' />
        </div>
        <div
          className='w-full bg-contain bg-right bg-no-repeat pb-15 pl-5 text-left max-md:bg-[length:100%_auto] max-md:bg-top max-md:p-4 max-md:pt-[100%]'
          style={{ backgroundImage: `url(${isMaxMd ? mobileBgImg : bgImg})` }}
        >
          <div className='bg-contain'>
            <h2 className='mt-[90px] font-[Prata] text-[56px] text-[#272727] max-md:mt-4 max-md:mb-8 max-md:text-center max-md:text-[28px]'>
              Profile
            </h2>
            <div className='flex w-[22.8%] flex-col gap-2 max-md:block max-md:w-full max-md:rounded-2xl max-md:bg-[#fff] max-md:p-4'>
              <Input className='relative max-md:mb-6' label='Username' value={profileStore.data?.userName} disabled />
              <Input className='relative max-md:mb-6' label='Name' value={profileStore.data?.name} disabled />
              <Input className='relative max-md:mb-6' label='Surname' value={profileStore.data?.surname} disabled />
              <Input className='relative max-md:mb-6' label='Email' value={profileStore.data?.email} disabled />
              <Input className='relative max-md:mb-6' label='Phone number' value={profileStore.data?.phone} disabled />
              <div className='mt-5 flex flex-col gap-4 max-md:hidden'>
                <Button fullWidth onClick={() => setShowChangePasswordModal(true)}>
                  Change password
                </Button>
                <Button fullWidth onClick={() => navigate(RoutePaths.profileSecurityAnswers.onNavigate())}>
                  Update security answers
                </Button>
              </div>
              <ul className='hidden flex-col gap-3 max-md:flex'>
                <li
                  className='relative flex h-[60px] w-full items-center justify-between bg-[#fff] font-[Prata] text-lg text-[#0f0f11]'
                  onClick={() => setShowChangePasswordModal(true)}
                >
                  <div className='flex items-center gap-2'>
                    <ChangePasswordIcon />
                    Change password
                  </div>
                  <ArrowMobileIcon />
                </li>
                <li
                  className='relative flex h-[60px] w-full items-center justify-between bg-[#fff] font-[Prata] text-lg text-[#0f0f11]'
                  onClick={() => navigate(RoutePaths.profileSecurityAnswers.onNavigate())}
                >
                  <div className='flex items-center gap-2'>
                    <ChangePasswordIcon />
                    Update security answers
                  </div>
                  <ArrowMobileIcon />
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <ChangePasswordModal
        isOpen={showChangePasswordModal}
        onClose={() => setShowChangePasswordModal(false)}
        onConfirm={() => setShowSuccessChangePasswordModal(true)}
      />
      <SuccessChangePasswordModal isOpen={showSuccessChangePasswordModal} onClose={() => setShowSuccessChangePasswordModal(false)} />
    </PageLayout>
  );
};
